.Header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-m);
}

.MenuWrapper {
  display: flex;
  gap: var(--space-m);
}

.Logo {
  width: var(--space-xxl);
}

.EnvLabel {
  position: absolute !important;
  text-transform: uppercase;
  left: 0;
  font-size: var(--font-size-xs);
}
